import axios from 'axios';
import { toast } from 'sonner';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const STATUS_STYLE = {
  paid_in_full: 'bg-green-100 text-green-800',
  partially_paid: 'bg-amber-100 text-amber-800',
  not_paid: 'bg-red-100 text-red-700',
  arrears_outstanding: 'bg-orange-100 text-orange-700',
  no_fee_structure: 'bg-slate-100 text-slate-600',
};

export const statusLabel = (s) => (s || '').replace(/_/g, ' ');

export const fmtUGX = (v) => `UGX ${Number(v || 0).toLocaleString()}`;

export const downloadFeesExport = async (reportKey, params, filename) => {
  try {
    const r = await axios.get(`${API_URL}/api/fees/export/${reportKey}`, { params, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    toast.success('Export downloaded');
  } catch {
    toast.error('Export failed');
  }
};

export const viewReceipt = async (paymentId) => {
  try {
    const r = await axios.get(`${API_URL}/api/fees/payments/${paymentId}/receipt`);
    const w = window.open('', '_blank');
    if (w) {
      const isPdf = r.data.receipt_data.startsWith('data:application/pdf');
      const el = w.document.createElement(isPdf ? 'iframe' : 'img');
      el.src = r.data.receipt_data;
      if (isPdf) {
        el.style.cssText = 'width:100%;height:100vh;border:0';
      } else {
        el.style.maxWidth = '100%';
        el.alt = 'receipt';
      }
      w.document.body.style.margin = '0';
      w.document.body.appendChild(el);
    }
  } catch (err) {
    toast.error(err.response?.data?.detail || 'No receipt found');
  }
};
